import React, { useRef, useEffect, useState } from "react";
import "./CartSheet.css";
import { useCart } from "../context/CartContext";

export default function CartSheet({ onViewCart }) {
  const { itemCount, grandTotal, clearCart } = useCart();
  const prevCount = useRef(itemCount);
  const barRef = useRef(null);
  const [confirming, setConfirming] = useState(false);
  const confirmTimer = useRef(null);

  useEffect(() => {
    if (itemCount > prevCount.current && barRef.current) {
      barRef.current.classList.remove("bounce");
      void barRef.current.offsetWidth;
      barRef.current.classList.add("bounce");
    }
    prevCount.current = itemCount;
  }, [itemCount]);

  useEffect(() => {
    return () => {
      if (confirmTimer.current) clearTimeout(confirmTimer.current);
    };
  }, []);

  const handleClearTap = () => {
    setConfirming(true);
    if (confirmTimer.current) clearTimeout(confirmTimer.current);
    confirmTimer.current = setTimeout(() => setConfirming(false), 4000);
  };

  const handleConfirmClear = () => {
    if (confirmTimer.current) clearTimeout(confirmTimer.current);
    setConfirming(false);
    clearCart({ clearSource: "cart_bar_clear" });
  };

  const handleCancelClear = () => {
    if (confirmTimer.current) clearTimeout(confirmTimer.current);
    setConfirming(false);
  };

  if (itemCount === 0) return null;

  if (confirming) {
    return (
      <div ref={barRef} className="cart-bar cart-bar-confirm" role="alert">
        <span className="cart-bar-confirm-text">Clear entire cart?</span>
        <span className="cart-bar-confirm-actions">
          <button className="cart-bar-confirm-yes" onClick={handleConfirmClear}>
            Yes, clear
          </button>
          <button className="cart-bar-confirm-no" onClick={handleCancelClear}>
            Cancel
          </button>
        </span>
      </div>
    );
  }

  return (
    <div ref={barRef} className="cart-bar" role="toolbar" aria-label="Cart">
      <button className="cart-bar-clear" onClick={handleClearTap} aria-label="Clear cart">
        <svg className="cart-bar-clear-icon" width="14" height="14" viewBox="0 0 16 18" fill="none">
          <path d="M5 0h6v2H5V0ZM0 3h16v1H0V3Zm2 2l1 12h10l1-12H2Zm4 2h1v8H6V7Zm3 0h1v8H9V7Z" fill="currentColor"/>
        </svg>
        Clear
      </button>
      <div className="cart-bar-main" onClick={onViewCart} role="button" tabIndex={0} aria-label="View cart">
        <span className="cart-bar-info">
          <span className="cart-bar-label">{itemCount} item{itemCount === 1 ? "" : "s"}</span>
          <strong className="cart-bar-total">₹{Math.round(grandTotal)}</strong>
        </span>
        <span className="cart-bar-cta">View Cart →</span>
      </div>
    </div>
  );
}
